"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectList = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("..");
const hooks_1 = require("../../../../../shared/hooks");
const tokens_1 = require("../../../../../styles/tokens");
const config_1 = require("../../config");
const hooks_2 = require("../../hooks");
const utils_1 = require("../../utils");
const SelectList_styles_1 = require("./SelectList.styles");
const { blue } = tokens_1.COLOURS.primary;
const renderOptions = (groupedOptions, theme, shouldDisplayValue, valueDescription) => {
    // The index is used for focus order when using a keyboard
    // tabIndex=0 is assigned to the main input if theme `ALL` is active, tabIndex=1 is assigned to `Select all options` and tabIndex=2 > is assigned to list items
    // If theme is `DEFAULT` `Select all options` is skipped and tabIndex=1 > is assigned to list items.
    let startingIndex = theme === "MULTISELECTALL" ? 2 : 1;
    let position = 1; // This is used for the aria-posinset labelling
    // Need to calculate the number of all the options to assign the aria-setsize
    const numOfOptions = groupedOptions.reduce((acc, group) => acc + group.options.length, 0);
    return groupedOptions.map((groupedOption, index) => {
        return (react_1.default.createElement(react_1.default.Fragment, { key: index },
            groupedOption.heading && (react_1.default.createElement(SelectList_styles_1.StyledSelectListHeader, null, groupedOption.heading)),
            groupedOption.options.map((option, i) => {
                const newOption = (react_1.default.createElement(__1.SelectItem, { option: option, index: startingIndex, key: i, ariaPosInset: position, ariaSetSize: numOfOptions, shouldDisplayValue: shouldDisplayValue, valueDescription: valueDescription }));
                startingIndex += 1;
                position += 1;
                return newOption;
            })));
    });
};
const SelectList = () => {
    const { options, defaultCopy, theme = "DEFAULT", activeOptionsList = [], selected = [], setSelected = () => [], id, shouldDisplayValues, valueDescription, } = (0, hooks_2.useSelect)();
    const listRef = (0, react_1.useRef)(null);
    const allRef = (0, react_1.useRef)(null);
    const [focusIndex, setFocusIndex] = (0, react_1.useState)(1);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        (_b = (_a = listRef === null || listRef === void 0 ? void 0 : listRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(`[tabIndex='${focusIndex}']`)) === null || _b === void 0 ? void 0 : _b.focus();
    }, [focusIndex]);
    const handleKeyNav = (e) => {
        if (e.code === config_1.KEYS.ARROW_UP ||
            e.code === config_1.KEYS.ARROW_LEFT ||
            e.key === config_1.KEYS.IE_ARROW_UP ||
            e.key === config_1.KEYS.IE_ARROW_LEFT) {
            setFocusIndex((0, utils_1.calculateNewFocus)(groupedOptions, focusIndex, -1, false, theme));
        }
        else if (e.code === config_1.KEYS.ARROW_DOWN ||
            e.code === config_1.KEYS.ARROW_RIGHT ||
            e.key === config_1.KEYS.IE_ARROW_DOWN ||
            e.key === config_1.KEYS.IE_ARROW_RIGHT) {
            setFocusIndex((0, utils_1.calculateNewFocus)(groupedOptions, focusIndex, 1, false, theme));
        }
    };
    const handleKeyDown = () => {
        selectAllHandler();
    };
    (0, hooks_1.useKey)([
        config_1.KEYS.ARROW_DOWN,
        config_1.KEYS.ARROW_UP,
        config_1.KEYS.ARROW_LEFT,
        config_1.KEYS.ARROW_RIGHT,
        config_1.KEYS.IE_ARROW_DOWN,
        config_1.KEYS.IE_ARROW_UP,
        config_1.KEYS.IE_ARROW_LEFT,
        config_1.KEYS.IE_ARROW_RIGHT,
    ], handleKeyNav, {
        target: listRef,
    });
    (0, hooks_1.useKey)([config_1.KEYS.ENTER, config_1.KEYS.SPACE], handleKeyDown, {
        target: allRef,
    });
    const selectAllHandler = () => {
        if (Array.isArray(selected) &&
            selected.length !== activeOptionsList.length) {
            const o = options.filter((option) => {
                return !option.disabled && option;
            });
            setSelected(o);
            return;
        }
        setSelected([]);
    };
    const defaultHeader = (theme === "MULTISELECTALL" && (defaultCopy === null || defaultCopy === void 0 ? void 0 : defaultCopy.headingContent)) || "";
    const groupedOptions = (0, utils_1.getGroupedOptions)(options, defaultHeader);
    return (react_1.default.createElement(SelectList_styles_1.StyledSelectListWrapper, { ref: listRef, "data-testid": "select-list" },
        theme === "MULTISELECTALL" && Array.isArray(selected) && (react_1.default.createElement("div", null,
            react_1.default.createElement(SelectList_styles_1.StyledSelectListHeader, { theme: theme }, defaultCopy === null || defaultCopy === void 0 ? void 0 : defaultCopy.headingAllOptions),
            react_1.default.createElement(SelectList_styles_1.StyledSelectListItems, { color: blue[100], role: "option", tabIndex: 0, ref: allRef, variant: "All" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(SelectList_styles_1.StyledSelectItemInput, { type: "checkbox", onChange: selectAllHandler, checked: selected.length === activeOptionsList.length, tabIndex: -1, "data-testid": "select-items-all" }),
                    react_1.default.createElement("span", null, defaultCopy === null || defaultCopy === void 0 ? void 0 : defaultCopy.valueSelectAll))))),
        react_1.default.createElement(SelectList_styles_1.StyledSelectList, { theme: theme, role: "listbox" }, renderOptions(groupedOptions, theme, shouldDisplayValues !== null && shouldDisplayValues !== void 0 ? shouldDisplayValues : false, valueDescription))));
};
exports.SelectList = SelectList;
//# sourceMappingURL=SelectList.js.map